'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))
var Task = /*#__PURE__*/ (function() {
  function Task(arg, queue) {
    ;(0, _defineProperty2.default)(this, '_countOfFailedRequests', 0)
    ;(0, _defineProperty2.default)(this, 'data', void 0)
    ;(0, _defineProperty2.default)(this, 'queue', void 0)
    ;(0, _defineProperty2.default)(this, 'id', void 0)
    ;(0, _defineProperty2.default)(this, 'type', void 0)
    ;(0, _defineProperty2.default)(this, 'status', 'pending')
    ;(0, _defineProperty2.default)(this, 'data', null)
    this.id = arg.id
    this.type = arg.type
    this.queue = queue
  }
  var _proto = Task.prototype
  _proto.update = function update(tdata) {
    var status = tdata.status
    switch (status) {
      case 'failed':
      case 'notfound':
        this.setThatFailed()
        break
      case 'done':
        this.setThatDone(tdata)
        break
      default:
        this.status = 'pending'
        break
    }
  }
  _proto.setThatFailed = function setThatFailed() {
    this._countOfFailedRequests += 1
    if (this._countOfFailedRequests >= Task.MAX_FAILED_REQUESTS) {
      this.queue.removeTask(this.id)
    }
  }
  _proto.setThatDone = function setThatDone(tdata) {
    var type = this.type,
      id = this.id
    var data = tdata.data
    this.queue._onTaskDone({ id: id, type: type, data: data })
  }
  _proto.destroy = function destroy() {
    delete this.queue
  }
  return Task
})()
;(0, _defineProperty2.default)(Task, 'MAX_FAILED_REQUESTS', 3)
var _default = Task
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TaskQueue/Task.js
// module id = 619
// module chunks = 0